(function() {
  'use strict';

  angular.module('widgets.dashboard', []);
})();
